// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/allowances",
  ListShort: "/pyr/allowances/short",
  Create: "/pyr/allowances",
  Update: "/pyr/allowances",
};
